export default {"src":"/_next/static/media/brave.06415a85.svg","height":18,"width":14,"blurWidth":0,"blurHeight":0};